import moment from "moment";
import { useEffect, useState } from "react";
import { Footer } from "../styled/common";

const KioskFooter = () => {
  const [currentTime, setCurrentTime] = useState(moment().format("YYYY년 MM월 DD일 A h시 m분"));

  useEffect(() => {
    let animationFrameId;

    const updateCurrentTime = () => {
      setCurrentTime(moment().format("YYYY년 MM월 DD일 A h시 m분"));
      animationFrameId = requestAnimationFrame(updateCurrentTime);
    };

    updateCurrentTime();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const isSungsim = (location.pathname.split("/")[2] || "kiosk") === "kiosk";

  return (
    <Footer className={isSungsim ? "sungsim" : "baseball"}>
      {currentTime}
      {isSungsim && (
        <div className="kioskLogo">
          <img src="/img/sungsimdang/sungsimdang.png" alt="" />
        </div>
      )}
    </Footer>
  );
};

export default KioskFooter;
